import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class IncomeClassificationTypeValueObject  {
    _originalTypeClassName = "zERP.BO.IncomeClassificationTypeValueObject";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
IncomeClassificationTypeValueObject.translate = translateService;
}
this.Category = [];
this.Id = null;
this.Name = null;
this.Description = null;
this.Code = null;
this.CodeStr = null;
this.FullName = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
Code:any;
CodeStr:any;
FullName:any;
Category:any;
static setCategory = ($this, items) => {
                if (items == null) items = [];
                if ($this.Category == null) $this.Category = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Category.length > 0) {
                    Domain.IncomeClassificationTypeValueObject.removeCategory($this, $this.Category[0]);
                }

                Domain.IncomeClassificationTypeValueObject.addManyCategory($this, copyItems);
            }
static addManyCategory = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.IncomeClassificationTypeValueObject.addCategory($this, items[i]);
                }
            }
static addCategory = ($this, item) => {
                if ($this.Category == null) $this.Category = [];
                if (item == null || $this.Category.indexOf(item) > -1) return;
                $this.Category.push(item);
Domain.IncomeClassificationCategoryValueObject.addTypes(item, $this);
}
static addRangeCategory = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.IncomeClassificationTypeValueObject.addCategory($this, item));
            }
static removeCategory = ($this, item) => {
                if ($this == null || $this.Category == null || $this.Category.indexOf(item) === -1) return;
                var _index = $this.Category.indexOf(item);
                $this.Category.splice(_index, 1);
Domain.IncomeClassificationCategoryValueObject.removeTypes(item, $this);
}
static clearCategory = ($this) => { $this.Category = null; }

static CodeToDescription($this: any): any{switch ($this?.Code) {case Domain.IncomeClassificationValueType.E3_106:
{
return "Ιδιοπαραγωγή παγίων - Αυτοπαραδόσεις - Καταστροφές αποθεμάτων/Εμπορεύματα";}
case Domain.IncomeClassificationValueType.E3_205:
{
return "Ιδιοπαραγωγή παγίων - Αυτοπαραδόσεις - Καταστροφές αποθεμάτων/Πρώτες ύλες και λοιπά υλικά";}
case Domain.IncomeClassificationValueType.E3_210:
{
return "Ιδιοπαραγωγή παγίων - Αυτοπαραδόσεις - Καταστροφές αποθεμάτων/Προϊόντα και παραγωγή σε εξέλιξη";}
case Domain.IncomeClassificationValueType.E3_305:
{
return "Ιδιοπαραγωγή παγίων - Αυτοπαραδόσεις – Καταστροφές αποθεμάτων/Πρώτες ύλες και λοιπά υλικά";}
case Domain.IncomeClassificationValueType.E3_310:
{
return "Ιδιοπαραγωγή παγίων - Αυτοπαραδόσεις - Καταστροφές αποθεμάτων/Προϊόντα και παραγωγή σε εξέλιξη";}
case Domain.IncomeClassificationValueType.E3_318:
{
return "Ιδιοπαραγωγή παγίων - Αυτοπαραδόσεις - Καταστροφές αποθεμάτων/Έξοδα παραγωγής";}
case Domain.IncomeClassificationValueType.E3_561_001:
{
return "Πωλήσεις αγαθών και υπηρεσιών Χονδρικές - Επιτηδευματιών";}
case Domain.IncomeClassificationValueType.E3_561_002:
{
return "Πωλήσεις αγαθών και υπηρεσιών Χονδρικές βάσει άρθρου 39α παρ 5 του Κώδικα Φ.Π.Α. (Ν.2859/2000)";}
case Domain.IncomeClassificationValueType.E3_561_003:
{
return "Πωλήσεις αγαθών και υπηρεσιών Λιανικές - Ιδιωτική Πελατεία";}
case Domain.IncomeClassificationValueType.E3_561_004:
{
return "Πωλήσεις αγαθών και υπηρεσιών Λιανικές βάσει άρθρου 39α παρ 5 του Κώδικα Φ.Π.Α. (Ν.2859/2000)";}
case Domain.IncomeClassificationValueType.E3_561_005:
{
return "Πωλήσεις αγαθών και υπηρεσιών Εξωτερικού Ενδοκοινοτικές";}
case Domain.IncomeClassificationValueType.E3_561_006:
{
return "Πωλήσεις αγαθών και υπηρεσιών Εξωτερικού Τρίτες Χώρες";}
case Domain.IncomeClassificationValueType.E3_561_007:
{
return "Πωλήσεις αγαθών και υπηρεσιών Λοιπά";}
case Domain.IncomeClassificationValueType.E3_562:
{
return "Λοιπά συνήθη έσοδα";}
case Domain.IncomeClassificationValueType.E3_563:
{
return "Πιστωτικοί τόκοι και συναφή έσοδα";}
case Domain.IncomeClassificationValueType.E3_564:
{
return "Πιστωτικές συναλλαγματικές διαφορές";}
case Domain.IncomeClassificationValueType.E3_565:
{
return "Έσοδα συμμετοχών";}
case Domain.IncomeClassificationValueType.E3_566:
{
return "Κέρδη από διάθεση μη κυκλοφορούντων περιουσιακών στοιχείων";}
case Domain.IncomeClassificationValueType.E3_567:
{
return "Κέρδη από αναστροφή προβλέψεων και απομειώσεων";}
case Domain.IncomeClassificationValueType.E3_568:
{
return "Κέρδη από επιμέτρηση στην εύλογη αξία";}
case Domain.IncomeClassificationValueType.E3_570:
{
return "Ασυνήθη έσοδα και κέρδη";}
case Domain.IncomeClassificationValueType.E3_595:
{
return "Έξοδα σε ιδιοπαραγωγή";}
case Domain.IncomeClassificationValueType.E3_596:
{
return "Επιδοτήσεις - Επιχορηγήσεις";}
case Domain.IncomeClassificationValueType.E3_597:
{
return "Επιδοτήσεις - Επιχορηγήσεις για επενδυτικούς σκοπούς - κάλυψη δαπανών";}
case Domain.IncomeClassificationValueType.E3_880_001:
{
return "Πωλήσεις Παγίων Χονδρικές";}
case Domain.IncomeClassificationValueType.E3_880_002:
{
return "Πωλήσεις Παγίων Λιανικές";}
case Domain.IncomeClassificationValueType.E3_880_003:
{
return "Πωλήσεις Παγίων Εξωτερικού Ενδοκοινοτικές";}
case Domain.IncomeClassificationValueType.E3_880_004:
{
return "Πωλήσεις Παγίων Εξωτερικού Τρίτες Χώρες";}
case Domain.IncomeClassificationValueType.E3_881_001:
{
return "Πωλήσεις για λογ/σμο Τρίτων Χονδρικές";}
case Domain.IncomeClassificationValueType.E3_881_002:
{
return "Πωλήσεις για λογ/σμο Τρίτων Λιανικές";}
case Domain.IncomeClassificationValueType.E3_881_003:
{
return "Πωλήσεις για λογ/σμο Τρίτων Εξωτερικού Ενδοκοινοτικές";}
case Domain.IncomeClassificationValueType.E3_881_004:
{
return "Πωλήσεις για λογ/σμο Τρίτων Εξωτερικού Τρίτες Χώρες";}
case Domain.IncomeClassificationValueType.E3_598_001:
{
return "Πωλήσεις αγαθών που υπάγονται σε ΕΦΚ";}
case Domain.IncomeClassificationValueType.E3_598_003:
{
return "Πωλήσεις για λογαριασμό αγροτών μέσω αγροτικού συνεταιρισμού κ.λ.π.";}
default:
{
return "";}
}
}
static DomainToInterface(incomeClassificationValueType: any): any{switch (incomeClassificationValueType) {case Domain.IncomeClassificationValueType.E3_106:
{
return 0 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_106 */;}
case Domain.IncomeClassificationValueType.E3_205:
{
return 1 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_205 */;}
case Domain.IncomeClassificationValueType.E3_210:
{
return 2 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_210 */;}
case Domain.IncomeClassificationValueType.E3_305:
{
return 3 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_305 */;}
case Domain.IncomeClassificationValueType.E3_310:
{
return 4 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_310 */;}
case Domain.IncomeClassificationValueType.E3_318:
{
return 5 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_318 */;}
case Domain.IncomeClassificationValueType.E3_561_001:
{
return 6 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_561_001 */;}
case Domain.IncomeClassificationValueType.E3_561_002:
{
return 7 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_561_002 */;}
case Domain.IncomeClassificationValueType.E3_561_003:
{
return 8 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_561_003 */;}
case Domain.IncomeClassificationValueType.E3_561_004:
{
return 9 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_561_004 */;}
case Domain.IncomeClassificationValueType.E3_561_005:
{
return 10 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_561_005 */;}
case Domain.IncomeClassificationValueType.E3_561_006:
{
return 11 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_561_006 */;}
case Domain.IncomeClassificationValueType.E3_561_007:
{
return 12 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_561_007 */;}
case Domain.IncomeClassificationValueType.E3_562:
{
return 13 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_562 */;}
case Domain.IncomeClassificationValueType.E3_563:
{
return 14 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_563 */;}
case Domain.IncomeClassificationValueType.E3_564:
{
return 15 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_564 */;}
case Domain.IncomeClassificationValueType.E3_565:
{
return 16 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_565 */;}
case Domain.IncomeClassificationValueType.E3_566:
{
return 17 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_566 */;}
case Domain.IncomeClassificationValueType.E3_567:
{
return 18 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_567 */;}
case Domain.IncomeClassificationValueType.E3_568:
{
return 19 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_568 */;}
case Domain.IncomeClassificationValueType.E3_570:
{
return 20 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_570 */;}
case Domain.IncomeClassificationValueType.E3_595:
{
return 21 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_595 */;}
case Domain.IncomeClassificationValueType.E3_596:
{
return 22 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_596 */;}
case Domain.IncomeClassificationValueType.E3_597:
{
return 23 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_597 */;}
case Domain.IncomeClassificationValueType.E3_880_001:
{
return 24 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_880_001 */;}
case Domain.IncomeClassificationValueType.E3_880_002:
{
return 25 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_880_002 */;}
case Domain.IncomeClassificationValueType.E3_880_003:
{
return 26 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_880_003 */;}
case Domain.IncomeClassificationValueType.E3_880_004:
{
return 27 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_880_004 */;}
case Domain.IncomeClassificationValueType.E3_881_001:
{
return 28 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_881_001 */;}
case Domain.IncomeClassificationValueType.E3_881_002:
{
return 29 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_881_002 */;}
case Domain.IncomeClassificationValueType.E3_881_003:
{
return 30 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_881_003 */;}
case Domain.IncomeClassificationValueType.E3_881_004:
{
return 31 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_881_004 */;}
case Domain.IncomeClassificationValueType.E3_598_001:
{
return 32 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_598_001 */;}
case Domain.IncomeClassificationValueType.E3_598_003:
{
return 33 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_598_003 */;}
default:
{
return 0 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_106 */;}
}
}
static GetCodeStr($this: any): any{return $this?.Code + "";
}
static GetEnums(): any{let incomeClassificationValueTypes = [];
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_106);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_205);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_210);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_305);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_310);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_318);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_561_001);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_561_002);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_561_003);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_561_004);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_561_005);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_561_006);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_561_007);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_562);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_563);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_564);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_565);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_566);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_567);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_568);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_570);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_595);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_596);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_597);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_880_001);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_880_002);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_880_003);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_880_004);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_881_001);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_881_002);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_881_003);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_881_004);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_598_001);
incomeClassificationValueTypes?.add(Domain.IncomeClassificationValueType.E3_598_003);
return incomeClassificationValueTypes;
}
static GetFullName($this: any): any{return $this?.Code + " - " + $this?.Name;
}
static InitializeTypeToCategoryAssociations(): any{}
static InterfaceToDomain(incomeClassificationValueType: any): any{switch (incomeClassificationValueType) {case 0 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_106 */:
{
return Domain.IncomeClassificationValueType.E3_106;}
case 1 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_205 */:
{
return Domain.IncomeClassificationValueType.E3_205;}
case 2 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_210 */:
{
return Domain.IncomeClassificationValueType.E3_210;}
case 3 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_305 */:
{
return Domain.IncomeClassificationValueType.E3_305;}
case 4 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_310 */:
{
return Domain.IncomeClassificationValueType.E3_310;}
case 5 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_318 */:
{
return Domain.IncomeClassificationValueType.E3_318;}
case 6 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_561_001 */:
{
return Domain.IncomeClassificationValueType.E3_561_001;}
case 7 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_561_002 */:
{
return Domain.IncomeClassificationValueType.E3_561_002;}
case 8 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_561_003 */:
{
return Domain.IncomeClassificationValueType.E3_561_003;}
case 9 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_561_004 */:
{
return Domain.IncomeClassificationValueType.E3_561_004;}
case 10 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_561_005 */:
{
return Domain.IncomeClassificationValueType.E3_561_005;}
case 11 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_561_006 */:
{
return Domain.IncomeClassificationValueType.E3_561_006;}
case 12 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_561_007 */:
{
return Domain.IncomeClassificationValueType.E3_561_007;}
case 13 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_562 */:
{
return Domain.IncomeClassificationValueType.E3_562;}
case 14 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_563 */:
{
return Domain.IncomeClassificationValueType.E3_563;}
case 15 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_564 */:
{
return Domain.IncomeClassificationValueType.E3_564;}
case 16 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_565 */:
{
return Domain.IncomeClassificationValueType.E3_565;}
case 17 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_566 */:
{
return Domain.IncomeClassificationValueType.E3_566;}
case 18 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_567 */:
{
return Domain.IncomeClassificationValueType.E3_567;}
case 19 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_568 */:
{
return Domain.IncomeClassificationValueType.E3_568;}
case 20 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_570 */:
{
return Domain.IncomeClassificationValueType.E3_570;}
case 21 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_595 */:
{
return Domain.IncomeClassificationValueType.E3_595;}
case 22 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_596 */:
{
return Domain.IncomeClassificationValueType.E3_596;}
case 23 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_597 */:
{
return Domain.IncomeClassificationValueType.E3_597;}
case 24 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_880_001 */:
{
return Domain.IncomeClassificationValueType.E3_880_001;}
case 25 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_880_002 */:
{
return Domain.IncomeClassificationValueType.E3_880_002;}
case 26 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_880_003 */:
{
return Domain.IncomeClassificationValueType.E3_880_003;}
case 27 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_880_004 */:
{
return Domain.IncomeClassificationValueType.E3_880_004;}
case 28 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_881_001 */:
{
return Domain.IncomeClassificationValueType.E3_881_001;}
case 29 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_881_002 */:
{
return Domain.IncomeClassificationValueType.E3_881_002;}
case 30 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_881_003 */:
{
return Domain.IncomeClassificationValueType.E3_881_003;}
case 31 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_881_004 */:
{
return Domain.IncomeClassificationValueType.E3_881_004;}
case 32 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_598_001 */:
{
return Domain.IncomeClassificationValueType.E3_598_001;}
case 33 /* Interfaces.AADESchema.IncomeClassificationValueType.E3_598_003 */:
{
return Domain.IncomeClassificationValueType.E3_598_003;}
default:
{
return Domain.IncomeClassificationValueType.E3_106;}
}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}